<template> <!-- OK -->
  <nav class="navbar">
    <div class="logo">
      <img src="../assets/Logo_radio.png" alt="Logo">
    </div>
    <div class="lateral" @click="toggleMenu">
      {{ lateralIcon }}
    </div>
    <div class="patrocinioContainer">
      <img src="../assets/lavanderia.jpeg" alt="Logo" id="logoPatrocinador">
    </div>
    <ul :class="{ 'nav-links': true, 'active': isMenuOpen }">
      <li>
        <router-link to="/homepage">Meu Grupo</router-link>
      </li>
      <li>
        <router-link to="/grupos">Grupos</router-link>
      </li>
      <li>
        <router-link to="/jogos">Jogos Realizados</router-link>
      </li>
      <li>
        <router-link to="/resultados">Lançar Resultados</router-link>
      </li>
      <li v-if="isAdmin">
        <router-link to="/admin">Editar</router-link>
      </li>
      <li class="mobile-only" v-if="isMobile" @click="goToSettings">Configurações</li>
      <li class="mobile-only" v-if="isMobile" @click="logout">Sair</li>
    </ul>
    <div class="user-info" v-if="!isMobile">
      <span>Olá, {{ fullName }}!</span>
      <img src="../assets/user.png" alt="User Icon" @click="toggleUserMenu" class="user-icon">
      <div v-if="isUserMenuOpen" class="user-menu">
        <ul>
          <li @click="goToSettings">Configurações</li>
          <li @click="logout">Sair</li>
        </ul>
      </div>
    </div>
  </nav>
</template>


<script>

import authService from '../services/authService';

export default {
  name: 'NavBar',
  data() {
    return {
      isMenuOpen: false,
      isUserMenuOpen: false,
      isMobile: window.innerWidth <= 768,
      lateralIcon: '\u2630',
      fullName: '',
      isAdmin: false
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    toggleUserMenu() {
      this.isUserMenuOpen = !this.isUserMenuOpen;
    },
    logout() {
      authService.logout();
      this.$router.push('/');
    },
    goToSettings() {
      this.$router.push('/settings');
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) {
        this.isMenuOpen = false;
      }
    },
    checkUser() {
      const user = authService.getCurrentUser();
      if (user && user.user) {
        this.fullName = user.user.fullName;
        this.isAdmin = user.user.isAdmin;
      } else {
        console.log('Nenhum usuário logado');
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.checkUser();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};

</script>

<style scoped>

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ECEFF1;
  padding: 10px 20px;
  position: relative;
}

.logo img {
  height: 40px;
}

.lateral {
  display: none;
  font-size: 30px;
  cursor: pointer;
}

.nav-links {
  list-style: none;
  display: flex;
  gap: 20px;
}

.nav-links li {
  display: inline;
}

.nav-links a {
  text-decoration: none;
  color: black;
  font-weight: bold;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
}

.user-icon {
  height: 30px;
  width: 30px;
  cursor: pointer;
}

.user-menu {
  position: absolute;
  top: 40px;
  right: 0;
  background-color: white;
  border: 1px solid #DDD;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  z-index: 10;
}

.user-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.user-menu li {
  padding: 10px;
  cursor: pointer;
}

.user-menu li:hover {
  background-color: #F0F0F0;
}

.mobile-only {
  display: none;
  cursor: pointer;
}

.patrocinioContainer {
  position: absolute;
  left: 6vw;
  pointer-events: none;
}

#logoPatrocinador {
  width: 120px;
}


@media screen and (max-width: 768px) {
  .nav-links {
    display: none;
    flex-direction: column;
    position: fixed;
    top: 0;
    right: 0;
    width: 250px;
    height: 100%;
    background-color: #ECEFF1;
    padding-top: 60px;
    transition: transform 0.3s ease-in-out;
    transform: translateX(100%);
  }

  .nav-links.active {
    display: flex;
    transform: translateX(0);
  }

  .nav-links li {
    margin-bottom: 20px;
    padding-left: 20px;
  }

  .lateral {
    display: block;
    z-index: 2;
  }

  .user-info {
    display: none;
  }

  .mobile-only {
    display: block;
  }

  .patrocinioContainer{
    width: 80px;
    left: 10vw;
  }
}
@media screen and (max-width: 1200px) {
  #logoPatrocinador {
    width: 120px;
    margin-left: 0vw;
  }
}

@media screen and (max-width: 450px) {
  #logoPatrocinador {
    margin-left: 20px;
    width: 120px;
  }
}

</style>